import { RoundedButton, ButtonColor, ButtonCorner } from "../Buttons/RoundedButton";
import Button from "../UIButton/UIButton";

export default function TreeBulkActionButton({ actionHandler, text }) {
    return (
        <div className="d-flex justify-content-end mb-2 p-2">
            <Button
                variant="primary"
                size="small"
                onClick={actionHandler}
            >{text}</Button>
        </div>
    )

}